enum ECompareMode {
  Grid = '2 x 2 Grid',
  Row = 'Single Row',
  Overlay = 'Overlay',
}

export default ECompareMode;
